import { Controller } from "@hotwired/stimulus"

// Toggle content visibility based on selected radio button
// Usage:
//   data-controller="radio-toggle"
//   data-radio-toggle-target="radio" on each radio input
//   data-radio-toggle-target="content" data-radio-toggle-show-value="published" on conditional content
//   data-action="change->radio-toggle#toggle" on radio inputs
export default class extends Controller {
  static targets = ["radio", "content"]

  connect() {
    this.toggle()
  }

  toggle() {
    const selected = this.radioTargets.find(r => r.checked)?.value
    this.contentTargets.forEach(content => {
      const showValues = content.dataset.radioToggleShowValue?.split(",") || []
      const isVisible = showValues.includes(selected)
      content.style.display = isVisible ? "block" : "none"

      // Disable/enable form inputs to prevent validation of hidden fields
      const inputs = content.querySelectorAll("input, select, textarea")
      inputs.forEach(input => {
        input.disabled = !isVisible
      })
    })
  }
}
